import { useNavigate } from "react-router";
import SetupEmail from "../components/email-setup";
import { useContext, useEffect } from "react";
import { AuthContext } from "../context/AuthContext";
import { getUserInfo } from "../utils/utils";
import { subscriptionPlans, userRoles } from "../config";
import useUpgradeAlert from "../common/hooks/useUpgradeAlert";

const EmailSetup = () => {
  const navigate = useNavigate();
  const { isAuthenticated, subscription } = useContext(AuthContext);
  const { isEmailSetupView } = useContext(AuthContext);
  const { role } = getUserInfo();
  const showUpgradeAlert = useUpgradeAlert(() => navigate("/pricing"));

  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/signin");
    }
    if (
      role === userRoles?.admin &&
      [subscriptionPlans?.trail].includes(
        subscription?.subscriptionPackage?.name
      )
    ) {
      showUpgradeAlert();
    } else if (!isEmailSetupView) {
      navigate("/dashboard-view");
    }
  }, [isEmailSetupView, navigate, isAuthenticated]);

  return <SetupEmail />;
};

export default EmailSetup;
